import { render, staticRenderFns } from "./mob.vue?vue&type=template&id=484c486f&scoped=true"
import script from "./mob.vue?vue&type=script&lang=ts"
export * from "./mob.vue?vue&type=script&lang=ts"
import style0 from "./mob.vue?vue&type=style&index=0&id=484c486f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484c486f",
  null
  
)

export default component.exports